import {
    get,
    post,
    execute
} from "./axios";

/**
 * 工单
 */
// 获取工单列表
export const GetWorkOrderList = data => execute('eshopapi/v1/ServiceWorkOrder/GetSearchPageData', data)
// 获取工单详情
export const GetWorkOrderDetail = data => execute('eshopapi/v1/ServiceWorkOrder/GetOrderDetail', data)
// 确认接单
export const MakeSureTakingWorkOrder = data => execute('eshopapi/v1/ServiceWorkOrder/MakeSureTakingWorkOrder', data)
// 客户签收入口二维码
export const GetEntranceQrCodeUrl = data => execute('eshopapi/v1/ServiceWorkOrder/GetOrderQrCodeUrl', data)
// 客户签收入数据
export const GetOrderSignReceivedInfo = data => execute('eshopapi/v1/ServiceWorkOrder/GetOrderSignReceivedInfo', data)
// 客户确认签收
export const SignReceivedWorkOrder = data => execute('eshopapi/v1/ServiceWorkOrder/SignReceivedWorkOrder', data)


/**
 * 地址
 */
// 收货地址列表
export const GetAddrList = data => execute('eshopapi/v1/DeliveryAddr/GetSearchPageData', data)
// 新增地址
export const AddAddress = data => execute('eshopapi/v1/DeliveryAddr/Add', data)
// 更新地址
export const UpdateAddress = data => execute('eshopapi/v1/DeliveryAddr/Update', data)
// 删除地址
export const DelAddress = data => execute('eshopapi/v1/DeliveryAddr/Delete', data)
// 获取服务省市接口
export const GetProList = data => execute('eshopapi/v1/Common/GetProvinceAndCityList', data)
// 获取服务区域接口
export const GetDisList = data => execute('eshopapi/v1/Common/GetDistrictList', data)
// 获取乡镇
export const GetTownList = data => execute('eshopapi/v1/Common/GetTownList', data)

/**
 * 用户登录
 */
// 登录
export const LoginByUsername = data => execute('api/v1/Login/LoginCheck', data)
// 手机号+验证码登录接口
export const LoginByMobile = data => execute('api/v1/Login/LoginCheck_VerCode', data)
// 获取登录验证码
export const GetLoginVerCode = data => execute('api/v1/Login/SendVerCode_Login', data)
// 对超时的accessToken,使用refreshtokne对accesstoken进行更新
export const LoginUpdate = data => execute('api/V1/Login/LoginUpdate', data)


/**
 * 售后
 */
// 获取售后单取件日期列表接口
export const GetReturnDateList = data => execute('eshopapi/v1/GoodsAfterSaleOrder/GetReturnDateList', data)
// 获取售后单商品信息
export const GetOrderAfterSaleGoodsMixInfo = data => execute('eshopapi/v1/GoodsAfterSaleOrder/GetOrderAfterSaleGoodsMixInfo', data)
// 上传临时图片凭证
export const UploadTempImage = data => execute('eshopapi/v1/GoodsAfterSaleOrder/UploadTempImage', data)
// 创建售后单
export const CreateAfterSaleOrder = data => execute('eshopapi/v1/GoodsAfterSaleOrder/CreateOrder', data)

/**
 * 售后
 */
// 获取客户订单详情
export const GetOrderDetail_H5 = data => execute('eshopapi/v1/SaleOrder/GetOrderDetail_H5', data)
// 保存订单客户签名
export const SaveCustomerSignImg_H5 = data => execute('eshopapi/v1/SaleOrder/SaveCustomerSignImg_H5', data)
// 保存订单客户预留手机
export const SaveCustomerMobile = data => execute('eshopapi/v1/SaleOrder/SaveCustomerMobile', data)
// 获取客户订单列表
export const GetCustomerOrder = data => execute('eshopapi/v1/SaleOrder/GetCustomerOrder', data)